import React,{useState,useEffect} from "react";
import "./style.scss";
import { MathUtils } from "../../utils";

const TrackRangeSlider = ({
  unitPreValue,
  title,
  min = 1,
  max = 3,
  value = { value: 2 },
  unit = "",
  step = 1,
  lang,
  isLoan,
  onChange = () => {},
}) => {
  const [selectedValue, setSelectedValue] = useState(value.value);

  useEffect(() => {
    setSelectedValue(value.value);
  },[value])
  return (
    <div className="track-range-slider">
      <h3>{title}</h3>
      <div className="track-wrapper">
        <input
          type="range"
          className="slider"
          min={min}
          max={max}
          value={selectedValue}
          step={step}
          onChange={(e) => setSelectedValue(e.target.value)}
          onMouseUp={(e) => onChange(selectedValue)}
          onTouchEnd={(e) => onChange(selectedValue)}
          onKeyUp={(e) => onChange(selectedValue)}
        />
        {unitPreValue ? (
          <label>
            {unit}
            {MathUtils.priceFormatSpecial(Number(selectedValue), lang, isLoan)}
          </label>
        ) : (
          <label>
            {MathUtils.priceFormatSpecial(Number(selectedValue), lang, isLoan)} {unit}
          </label>
        )}
      </div>
    </div>
  );
};

export default TrackRangeSlider;
